export function addTrackingIdToUrl(url: string, trackingID?: string): string {
	if (!url || !trackingID) return url
	return url + `&subid2=${trackingID}&sharedid=${trackingID}`
}
